import type { BaseQueryFn } from "@reduxjs/toolkit/query";
import type { AxiosRequestConfig } from "axios";
import { logError, normalizeError, type AppError } from "@shared/lib/errors";
import axiosClient from "./axiosClient";

export const axiosBaseQuery =
  ({ baseUrl = "" }: { baseUrl?: string } = {}): BaseQueryFn<
    {
      url: string;
      method?: AxiosRequestConfig["method"];
      data?: unknown;
      params?: unknown;
      headers?: AxiosRequestConfig["headers"];
    },
    unknown,
    AppError
  > =>
  async ({ url, method = "GET", data, params, headers }) => {
    try {
      const res = await axiosClient({ url: baseUrl + url, method, data, params, headers });
      return { data: res.data };
    } catch (error) {
      const appError = normalizeError(error);
      logError(appError, `${method} ${url}`);
      return { error: appError };
    }
  };
